import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CommentRegasyncReqPros, CommentRegInitialState } from "../model/CommentRegReducerType";

const reducerId = "CommentRegReducer/asyncReqCommentReg";
const controllerMap = new Map();

const initialState: CommentRegInitialState = {
    status: "",
    n4ErrorCode: 0,
    strErrorMessage: "",
    isSuccess: false,
    INFO: {
        UBC_BOARD_SEQ: "",
        UBC_COMMENT_SEQ: "",
        UBC_REF_COMMENT_SEQ: "",
        UBC_CONTENT: "",
        UBC_REG_MEM_UDID: "",
        UBC_REG_DT: "",
        UMM_NICKNAME: ""
    }
};

const slice = createSlice({
    name: "CommentRegReducer",
    initialState,
    reducers: {
        setInitStatus: (state) => {
            state.status = "";
        }
    },
    extraReducers: (builder) => {
        builder.addCase(asyncReqCommentReg.pending, (state) => {
            state.status = "LOADING";
        });
        builder.addCase(asyncReqCommentReg.fulfilled, (state, action) => {
            state.status = "COMPLETE";
            state.n4ErrorCode = action.payload.n4ErrorCode;
            state.strErrorMessage = action.payload.strErrorMessage;
            state.isSuccess = action.payload.isSuccess;
            state.INFO = action.payload.INFO;
        });
        builder.addCase(asyncReqCommentReg.rejected, (state, action) => {
            if (action.payload?.aborted) return; // 'AbortError'로 인한 취소라면 상태 변경하지 않음
            state.status = "FAIL";
        });
    }
});

type RejectPayload = { aborted: boolean; message?: string };

export const asyncReqCommentReg = createAsyncThunk<
        any, // 성공 시 반환 타입 (API 응답 타입)
        CommentRegasyncReqPros, // thunk 파라미터 타입
        {
            rejectValue: RejectPayload; // ❗ rejectWithValue 타입 명시
        }
    >(
    reducerId,
    async ({ board_seq, ref_comment_seq, nickname, comment, reg_udid }: CommentRegasyncReqPros, thunkAPI) => {
        // 이전 요청이 있으면 취소
        const prevController = controllerMap.get(reducerId);
        if (prevController) prevController.abort();

        // 새 요청용 controller 생성
        const controller = new AbortController();
        controllerMap.set(reducerId, controller);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_DOMAIN}/ApiReact/CommentReg.aspx?board_seq=${encodeURIComponent(board_seq)}&ref_comment_seq=${encodeURIComponent(ref_comment_seq)}&nickname=${encodeURIComponent(nickname)}&comment=${encodeURIComponent(comment)}&reg_udid=${encodeURIComponent(reg_udid)}`,
                {
                    signal: controller.signal,
                }
            );
            const data = await res.json();
            return data;
        }
        catch (error: any) {
            // ❗ AbortError인 경우는 구분해서 처리
            if (error.name === "AbortError") {
                return thunkAPI.rejectWithValue({ aborted: true });
            }
            return thunkAPI.rejectWithValue({ aborted: false, message: error.message });
        }
    }
);

export const CommentRegActions = slice.actions;
export default slice.reducer;